import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { OtpService, UserService } from "@/services";
import otpService from "@/services/modules/otpService";
import vueAwesomeCountdown from "vue-awesome-countdown";

export default {
  name: "enable-2fa-for-login",
  components: { vueAwesomeCountdown },
  props: [],
  data() {
    return {
      twoFactorId: 1,
      activationType: "",
      inactiveModal: false,
      inactivePassword: "",
      showInactivePassword: false,
      activeModal: false,
      activePassword: "",
      activeCode: "",
      showActivePassword: false,
      ttl: 0,
      previousOtpState: ""
    };
  },
  computed: {
    ...mapGetters({
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO,
      userInfo: types.userInfo.getters.GET_USER_INFO
    }),
    isGoogleVerified() {
      return this.userVerifyInfo.is_google2fa_active;
    },

    isMobileVerified() {
      return this.userVerifyInfo.is_mobile_verified;
    },

    isEmailVerified() {
      return this.userVerifyInfo.is_email_verified;
    }
  },
  mounted() {},
  methods: {
    ...mapActions({
      setShow2FA: types.account.actions.SET_SHOW_2FA,
      setUserData: types.userInfo.actions.ACTION_USER_INFO
    }),
    resetData() {
      this.activePassword = "";
      this.activeCode = "";
      this.inactivePassword = "";
    },
    closeActiveModal() {
      this.activeModal = false;
      this.onExpiredTime();
      this.getUserInfo();
      this.resetData();
    },
    onExpiredTime() {
      this.ttl = 0;
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    },
    hide2FASection() {
      this.setShow2FA(false);
    },

    openDefault2FA(type) {
      this.previousOtpState = this.userInfo.two_factor_auth_default;
      this.activationType = type;
      this.activeModal = true;
      this.resetData();
    },
    activate2FA() {
      otpService
        .verifyAndDefault(
          this.activationType,
          this.activeCode,
          this.activePassword
        )
        .then(res => {
          this.closeActiveModal();
          this.$toast.success(res.data.message);
        });
    },

    openInactiveModal() {
      this.inactiveModal = true;
    },
    sendOtpCode(activationType) {
      if (activationType === "sms") {
        otpService.activeSms(this.userVerifyInfo.mobile).then(res => {
          this.ttl = res.data.data.ttl;
          // this.resetMobileCounter();
          this.$toast.success(res.data.message);
        });
      } else if (activationType === "email") {
        otpService.activeEmail(this.userVerifyInfo.email).then(res => {
          this.ttl = res.data.data.ttl;
          // this.resetMobileCounter();
          this.$toast.success(res.data.message);
        });
      } else {
        otpService.activeGoogle().then(res => {
          // this.ttl = res.data.data.ttl;
          // this.resetMobileCounter();
          this.$toast.success(res.data.message);
        });
      }
    },
    inactive2fa() {
      OtpService.inactive(this.inactivePassword).then(res => {
        // this.setGoogleVerification("inActive");
        this.getUserInfo();
        this.resetData();
        this.inactiveModal = false;
        this.$toast.success(res.data.message);
        this.inactivePassword = "";
      });
    },
    itemsDisabledStates(type) {
      if (type === "sms") {
        return this.isMobileVerified;
      } else if (type === "email") {
        return this.isEmailVerified;
      } else {
        return this.isGoogleVerified;
      }
    }
  }
};
